<template>
  <div>
    <page-header>
      <div slot="content">
        <header-title link="/services" title="Services"></header-title>
        <div class="menu">
          <ul class="unstyled">
            <li v-for="(service, index) in menuServices" :key="index">
              <a 
                @click="setActiveService(index)" 
                v-scroll-to="{el: service.hash, offset: -100}" 
                class="nav-item"
                :class="activeService == service ? 'active' : null"
              >{{ service.title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </page-header>
    <div class="body">
      <h1 id="summary" class="align-right">We want to help you out, and we do a lot of things, so odds are that what you need done matches up with what we're able to do. Whether you need help fleshing out your idea and how to implement it, or you need help building out what you've already planned, or you just need some things fixed and maintained, we've got you covered.</h1>
    </div>
    <div id="sub-sections">
      <div id="services" class="sub-section">
        <div class="grid">
          <service v-for="(service, index) in services" 
            :key="index" 
            :service="service" 
            :active="activeService == service"
            v-on:activated="setActiveService(index)"
          ></service>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import DataStore from '@/storage/data'
import HeaderTitle from '@/components/HeaderTitle'
import PageHeader from '@/components/PageHeader'
import Service from './Service'
export default {
  name: 'services',
  props: {
    scrollPosition: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      services: DataStore.services,
      activeService: null
    }
  },
  mounted () {
    let hash = window.location.hash
    if (hash) {
      this.setActiveService(this.services.indexOf(this.services.find((service) => { return service.hash === hash })))
      this.$scrollTo(hash)
    }
  },
  computed: {
    menuServices () {
      return this.services.slice(0, 4)
    }
  },
  methods: {
    setActiveService (index) {
      this.activeService = this.services[index]
    }
  },
  components: {
    HeaderTitle,
    PageHeader,
    Service
  }
}
</script>



// WEBPACK FOOTER //
// Services.vue?c2b89a38